import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductImage from "../Assets/loading.png";
import { CART_API_URL } from "../config/api";

const PremiumProducts = ({ type = "Premium Products", APIdata }) => {
  const navigate = useNavigate();
  const [addedIds, setAddedIds] = useState({});
  const [loadingIds, setLoadingIds] = useState({});

  const products = useMemo(() => {
    if (APIdata && APIdata.length) {
      return APIdata.map((p) => ({
        id: p.Id || p.id || p.ProductId,
        name: p.ProductName || p.name || p.Title,
        price: p.Price ? `₹${p.Price}` : p.price,
        img: p.ProductImage || p.image || p.Image || ProductImage,
        Quantity: p.Quantity ?? p.quantity ?? 1,
      }));
    }
    return [];
  }, [APIdata]);

  const addToCart = async (e, productId) => {
    e.stopPropagation();
    const mobileNo = localStorage.getItem("userMobileNumber");
    if (!mobileNo) {
      navigate("/login");
      return;
    }
    setLoadingIds((s) => ({ ...s, [productId]: true }));
    try {
      const res = await fetch(`${CART_API_URL}/Cart/UpdateCart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNo, productId, action: "addProduct" }),
      });
      if (!res.ok) throw new Error("Cart update failed");
      setAddedIds((s) => ({ ...s, [productId]: true }));
    } catch {
      alert("Add to cart failed — dobara try karein");
    } finally {
      setLoadingIds((s) => ({ ...s, [productId]: false }));
    }
  };

  if (!products.length) return null;

  const loopProducts = [...products, ...products];

  return (
    <section style={{ marginTop: "24px", position: "relative" }}>
      <h2 style={{ marginBottom: "8px", fontSize: "20px", fontWeight: 700 }}>
        ✨ {type}
      </h2>
      <div style={{ position: "relative", textAlign: "center" }}>
        <div className="marquee-wrap" style={{ padding: "10px" }}>
          <div className="marquee-track">
            {loopProducts.map((product, idx) => (
              <div
                onClick={() => navigate(`/product-details/${product.id}`)}
                key={`${product.id}-${idx}`}
                style={{
                  minWidth: "180px",
                  width: "180px",
                  border: "1px solid #f5d996",
                  borderRadius: "8px",
                  padding: "10px",
                  background: "linear-gradient(135deg, #fffbeb, #fff)",
                  boxShadow: "0 4px 12px rgba(201,160,30,0.18)",
                  boxSizing: "border-box",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <img
                  src={product.img || ProductImage}
                  alt={product.name}
                  loading="lazy"
                  decoding="async"
                  style={{ width: "100%", height: "140px", objectFit: "cover", borderRadius: "6px" }}
                />
                <div style={{ marginTop: "8px", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {product.name}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "4px" }}>
                  <div style={{ color: "#2a7", fontWeight: 700 }}>{product.price}</div>
                  <div
                    style={{
                      fontSize: "11px", fontWeight: 700, color: "#92400e",
                      background: "#fef3c7", padding: "2px 6px", borderRadius: "6px",
                    }}
                  >
                    Qty: {product.Quantity}
                  </div>
                </div>

                <button
                  onClick={(e) => addToCart(e, product.id)}
                  disabled={loadingIds[product.id] || addedIds[product.id]}
                  style={{
                    marginTop: "8px",
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: addedIds[product.id] ? "default" : "pointer",
                    fontWeight: 700,
                    fontSize: "12px",
                    color: "#fff",
                    background: addedIds[product.id]
                      ? "linear-gradient(135deg, #16a34a, #22c55e)"
                      : "linear-gradient(135deg, #ff9f00, #fb641b)",
                    opacity: loadingIds[product.id] ? 0.7 : 1,
                    boxShadow: addedIds[product.id]
                      ? "0 3px 10px rgba(22,163,74,0.3)"
                      : "0 3px 10px rgba(251,100,27,0.3)",
                    transition: "all 0.2s",
                  }}
                >
                  {loadingIds[product.id]
                    ? "Adding..."
                    : addedIds[product.id]
                    ? "✓ Added to Cart"
                    : "🛒 Add to Cart"}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default PremiumProducts;
